import { render, staticRenderFns } from "./menuAdmin.vue?vue&type=template&id=bb169b2e"
import script from "./menuAdmin.vue?vue&type=script&lang=js"
export * from "./menuAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports